module.exports = __webpack_public_path__ + "images/897a9d33ed4d6832b654f144b4c78e89.svg";